import { render, staticRenderFns } from "./unfixedThead.vue?vue&type=template&id=49227a4c"
import script from "./unfixedThead.vue?vue&type=script&lang=js"
export * from "./unfixedThead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports